<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Kebijakan Umum SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Periode Renstra</span>
                                <select @change="getRenstraMisi()" class="form-control show-tick" v-model="id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <span class="huruf_input">Misi SKPD</span>
                                <select @change="cari_data()" class="form-control show-tick" v-model="renstra_misi_id">
                                    <option value="" >-- Semua Misi --</option>
                                    <option v-for="data in list_Renstra_Misi" :key="data.renstra_misi_id" :value="data.renstra_misi_id">{{data.uraian}}</option>
                                </select>
                            </div>
                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="text-center" style="width: 5%">Kode.</th>
                                    <th class="text-center" style="width: 40%">
                                        <!-- Uraian Tujuan /  -->
                                        Strategi SKPD
                                    </th>
                                    <th class="text-center" style="width: 40%">Sasaran RPJMD</th>
                                    <th class="text-center" style="width: 15%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                    <template v-for="(data, index) in list_data">
                                        <!-- <tr class="h_isitabl2 bgcol-abuabumuda" :key="index+data.renstra_strategi_id">
                                            <td class="tabel_center">{{data.nomor_renstra_misi}}.{{data.no_renstra_tujuan}}</td>
                                            <td class="tabel_center" colspan="3">{{data.renstra_tujuan_uraian}}</td>
                                        </tr> -->
                                        <tr class="h_isitable" :key="index+data.renstra_kebijakan_umum_id">
                                            <td class="tabel_center">{{data.nomor_renstra_misi}}.{{data.no_renstra_strategi}}.{{data.no_renstra_kebijakan_umum}}</td>
                                            <td class="tabel_center">{{data.uraian}}</td>
                                            <td class="tabel_center">[{{data.rpjmd_kode_arah_kebijakan}}]&nbsp; &nbsp;{{data.kebijakan_umum_uraian}}</td>

                                            <td class="tabel_center text-center" >

                                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                                    <i class="material-icons" >create</i>
                                                </button>
                                                &nbsp;
                                                <button @click="removeData(data.renstra_kebijakan_umum_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                                    <i class="material-icons" >clear</i>
                                                </button>

                                            </td>
                                        </tr>
                                    </template>
                                

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>


                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RENSTRA DAN MISI SKPD TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Periode Rpjmd</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select class="form-control show-tick" v-model="rpjmd_id" @change="getKebijakanUmum">
                                                                        <option value="" >-- Pilih Periode --</option>
                                                                        <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Kebijakan Umum RPJMD</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select class="form-control show-tick" v-model="kebikan_umum_id">
                                                                        <option value="" >-- Pilih Kebijakan Umum RPJMD --</option>
                                                                        <option v-for="data in list_kebijakan_umum" :key="data.kebikan_umum_id" :value="data.kebikan_umum_id">[{{data.kode}}] {{data.uraian}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Kebijakan Umum SKPD</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <select class="form-control show-tick" v-model="renstra_strategi_id">
                                                                        <option value="" >-- Pilih strategi Pembangunan SKPD --</option>
                                                                        <option v-for="data in list_Renstra_Strategi" :key="data.renstra_strategi_id" :value="data.renstra_strategi_id">[{{data.no_renstra_strategi}}] {{data.uraian}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode" style="font-size:89%">Perspektif Kebijakan</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control" v-model="perspektif_id">
                                                                    <option v-for="data in list_perspektif" :key="data.perspektif_id" :value="data.perspektif_id">{{data.perspektif}}</option>
                                                                </select>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">No Strategi SKPD</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input :required="true" v-model="no_renstra_kebijakan_umum" type="number" class="datepicker form-control" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Uraian </label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input v-model="uraian" type="text" class="datepicker form-control" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Keterangan </label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Periode Rpjmd</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control show-tick" v-model="rpjmd_id" @change="getKebijakanUmum">
                                                                    <option value="" >-- Pilih Periode --</option>
                                                                    <option v-for="data in list_RPJMD" :key="data.rpjmd_id" :value="data.rpjmd_id">{{data.periode}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Kebijakan Umum RPJMD</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control show-tick" v-model="kebikan_umum_id">
                                                                    <option value="" >-- Pilih Kebijakan Umum RPJMD --</option>
                                                                    <option v-for="data in list_kebijakan_umum" :key="data.kebikan_umum_id" :value="data.kebikan_umum_id">[{{data.kode}}] {{data.uraian}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Kebijakan Umum SKPD</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <select class="form-control show-tick" v-model="renstra_strategi_id">
                                                                    <option value="" >-- Pilih strategi Pembangunan SKPD --</option>
                                                                    <option v-for="data in list_Renstra_Strategi" :key="data.renstra_strategi_id" :value="data.renstra_strategi_id">[{{data.no_renstra_strategi}}] {{data.uraian}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode" style="font-size:89%">Perspektif Kebijakan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                        <div class="form-line">
                                                            <select class="form-control" v-model="perspektif_id">
                                                                <option v-for="data in list_perspektif" :key="data.perspektif_id" :value="data.perspektif_id">{{data.perspektif}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Strategi SKPD</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input :required="true" v-model="no_renstra_kebijakan_umum" type="number" class="datepicker form-control" >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian </label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="datepicker form-control" >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan </label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renstra_kebijakan_umum/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_RENSTRA_MISI = URL_APP+'api/v1/planning_renstra_misi/';
    const ADD_URL_RENSTRA_STRATEGI = URL_APP+'api/v1/planning_renstra_strategi/'
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_KEBIJAKAN_UMUM = URL_APP+'api/v1/planning_kebijakan_umum/';

    const ADD_URL_PERSPEKTIF = URL_APP+'api/v1/planning_perspektif_kebijakan/';

    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                renstra_kebijakan_umum_id : '',

                rpjmd_id : '',
                kebikan_umum_id : '',

                id_renstra : '',
                renstra_misi_id : '',
                renstra_misi_id_edit : '',
                renstra_strategi_id : '',

                no_renstra_kebijakan_umum : 0,
                uraian : '',
                keterangan : '',
                perspektif_id : '',

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',

                check_data_add : false,

                list_Renstra: [],
                list_Renstra_Misi: [],
                list_Renstra_Strategi: [],
                list_RPJMD : [],
                list_kebijakan_umum : [],
                list_perspektif : [],
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;

            this.getData();
            this.getRenstra();
            this.getRPJMD();
            this.getPersepktif();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        id_renstra : this.id_renstra,
                        rpjmd_id : this.rpjmd_id,
                        renstra_misi_id : this.renstra_misi_id,
                        renstra_strategi_id : this.renstra_strategi_id,
                        kebikan_umum_id : this.kebikan_umum_id,
                        no_renstra_kebijakan_umum : this.no_renstra_kebijakan_umum,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        perspektif_id : this.perspektif_id,
                        unit_kerja : this.unit_kerja,
                    })
                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        id_renstra : this.id_renstra,
                        unit_kerja : this.unit_kerja,
                        renstra_misi_id : this.renstra_misi_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_kebijakan_umum_id : this.renstra_kebijakan_umum_id,
                        id_renstra : this.id_renstra,
                        rpjmd_id : this.rpjmd_id,
                        renstra_misi_id : this.renstra_misi_id_edit,
                        renstra_strategi_id : this.renstra_strategi_id,
                        kebikan_umum_id : this.kebikan_umum_id,
                        no_renstra_kebijakan_umum : this.no_renstra_kebijakan_umum,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        perspektif_id : this.perspektif_id,
                        unit_kerja : this.unit_kerja_edit,
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.renstra_kebijakan_umum_id = data.renstra_kebijakan_umum_id;
                this.id_renstra = data.id_renstra;
                this.rpjmd_id = data.rpjmd_id;
                this.renstra_misi_id_edit = data.renstra_misi_id;
                this.renstra_strategi_id = data.renstra_strategi_id;
                this.kebikan_umum_id = data.kebikan_umum_id;
                this.no_renstra_kebijakan_umum = data.no_renstra_kebijakan_umum;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.perspektif_id = data.perspektif_id;
                this.unit_kerja_edit = data.unit_kerja;


                this.getRenstraStrategi(data.renstra_misi_id)
                this.getKebijakanUmum();
                this.getPersepktif();

                // console.log(data);
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.kebikan_umum_id = '';
                this.no_kebikan_umum = '';
                this.uraian = '';
            },

        //TAMBAHAN
            getRPJMD : function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                })
            },
            getKebijakanUmum : function(){
                if (this.rpjmd_id == '') { this.misi_id =''} // Agar ketika pilih Periode RPJMD = 'semua periode' maka semua data akan tampil
                fetch(ADD_URL_KEBIJAKAN_UMUM, {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.rpjmd_id
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_kebijakan_umum = res_data;
                    console.log("STRAAAATEGI");
                    console.log(res_data);
                })
            },

            getRenstra : function(){
                this.page_first = 1;
                fetch(ADD_URL_RENSTRA, {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_Renstra = res_data;
                    this.getData();
                    // console.log(res_data);
                })
            },
            getRenstraMisi : function(){
                this.page_first = 1;
                if (this.id_renstra == '') {
                    this.renstra_misi_id = '';
                    this.list_Renstra_Misi = [];
                }else{
                    fetch(ADD_URL_RENSTRA_MISI, {
                        method : 'POST',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        },
                        body : JSON.stringify({
                            unit_kerja : this.unit_kerja
                        })
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_Renstra_Misi = res_data;
                        // console.log(res_data);
                    })

                }
            },

            getRenstraStrategi : function(vrenstra_misi_id){
                this.page_first = 1;
                if (this.id_renstra == '') {
                    this.renstra_misi_id = '';
                }
                fetch(ADD_URL_RENSTRA_STRATEGI, {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        renstra_misi_id : vrenstra_misi_id,
                        unit_kerja : this.unit_kerja
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_Renstra_Strategi = res_data;
                    // console.log(res_data);
                })
            },
            getPersepktif : function(){
                this.page_first = 1;
                if (this.misi_id == '') {this.check_misi = false; this.getData();} 
                else {
                    this.check_misi = true;
                    fetch(ADD_URL_PERSPEKTIF, {
                        method : 'GET',
                        headers : {
                            'content-type' : 'application/json',
                            authorization : 'kikensbatara '+localStorage.token
                        }
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_perspektif = res_data;
                        // this.getData();
                        // console.log(res_data);
                    })
                }
            },
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getRenstra();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){

                if (this.id_renstra != '' && this.renstra_misi_id != '') {
                    this.check_data_add = true;
                    this.getRenstraStrategi(this.renstra_misi_id);
                }
            } 
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
